( function( $ ) {
	'use strict';

	$( function() {
		let lastScrollTop = 0;
		const headerHeight = $( '.site-header' ).height();
		const contentPosition = 200;
		const $body = $( 'body' );
		const bodyClass = 'is-stuck--main-menu';

		function hideHeader() {
			// If the fixed header is active, hide it
			if ( $body.hasClass( bodyClass ) ) {
				$body.removeClass( bodyClass );
			}
		}

		$( window ).on('scroll',function() {
			const scrollTop = $( this ).scrollTop();

			// If scrolling up
			if ( lastScrollTop > scrollTop ) {

				// If we're past the top of the page content
				if ( scrollTop > contentPosition ) {

					//Show the fixed header
					if ( ! $body.hasClass( bodyClass ) ) {
						$body.addClass( bodyClass );
					}

					// If we're over the top of the page content
				} else {
					$( '.js-sticky-header' ).removeClass( 'site-header--sticky' );
					hideHeader();
				}

				// If scrolling down
			} else {
				if ( scrollTop > contentPosition ) {
					$( '.js-sticky-header' ).addClass( 'site-header--sticky' );
					hideHeader();
				} else {
					$( '.js-sticky-header' ).removeClass( 'site-header--sticky' );
				}
			}

			lastScrollTop = scrollTop;
		});
	} );
} )( jQuery );
